import type { BuildInfo } from '../../build/build-info';

/**
 * A build as people can compare it: the commit, and when it was made in their
 * own time zone ("2e481b0 · 15 Eki 18:40"). A local build has no date worth showing.
 */
export function buildLabel(build: BuildInfo, locale: string, timeZone?: string): string {
  const builtAt = new Date(build.builtAt);
  if (build.commit === 'local' || builtAt.getTime() <= 0) return build.commit;
  const when = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit', timeZone }).format(builtAt);
  return `${build.commit} · ${when}`;
}
